import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiUrlService } from '@core/services/common/api-url.service';
import { MediaResponse } from '@modules/editor/services/content-media-api.service';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';

@Injectable()
export class ArtworkRequestFormService {
  private readonly formApiUrl = this.apiUrlService.getApiUrl() + 'client/artwork-request-form';
  private readonly uploadImageApiUrl = this.apiUrlService.getApiUrl() + 'client/artwork-request-form/media';
  private readonly uploadAttachmentApiUrl = this.apiUrlService.getApiUrl() + 'client/artwork-request-form/attachment';

  constructor(
    private httpClient: HttpClient,
    private apiUrlService: ApiUrlService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  sendMessage(data: any, withPageUrlParam = false, typ_block_form_id) {
    data['typ_block_form'] = typ_block_form_id;
    const pageUrlParam = withPageUrlParam ?
      `?pageUrl=${this.document.location.pathname}`
      : '';
    const url = this.formApiUrl + pageUrlParam;
    return this.httpClient
      .post(url, data, {
        headers: new HttpHeaders({'Content-Type': 'application/json'}),
      })
      .pipe(
        catchError((message) => throwError(() => message)),
      );
  }

  uploadImage(file: File, onProgress?: (percent: number) => void): Observable<MediaResponse> {
    return this.upload(this.uploadImageApiUrl, file, onProgress);
  }

  uploadAttachment(file: File, onProgress?: (percent: number) => void): Observable<MediaResponse> {
    return this.upload(this.uploadAttachmentApiUrl, file, onProgress);
  }

  private upload(url: string, file: File, onProgress?: (percent: number) => void): Observable<MediaResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<MediaResponse>(url, formData, {
      reportProgress: true,
      observe: 'events',
    }).pipe(
      tap((event: HttpEvent<MediaResponse>) => {
        if (event.type === HttpEventType.UploadProgress && onProgress) {
          const percent = Math.round((event.loaded / (event.total ?? 1)) * 100);
          onProgress(percent);
        }
      }),
      // AT-8869: bez filtra subscribe dostawał każdy HttpEvent (progress) i robił --
      // na liczniku uploadów → disabled „Wyślij” znikał natychmiast.
      filter((event: HttpEvent<MediaResponse>): event is HttpResponse<MediaResponse> =>
        event.type === HttpEventType.Response
      ),
      map(event => event.body as MediaResponse),
      catchError(error => {
        return throwError(() => error);
      }),
    );
  }
}
